/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import styled from 'styled-components'
import { Header, Icon } from 'semantic-ui-react'

const Content = styled.div`
  position: relative;
`

export default ({ title = "Map", onClose, children }) => (
  <div id="driver-map-view" className="map-hide">
    <div className="map-dimmer" onClick={onClose} />
    <div className="map-container">
      <Content>
        <Header
          content={title}
          size="large"
          style={{ padding: 13, margin: 0 }}
        />
        <div className="driver-map-cancel-icon">
          <Icon name="cancel" size="large" onClick={onClose} />
        </div>
      </Content>

      {children}
    </div>
  </div>
)


// WEBPACK FOOTER //
// ./src/containers/mapView/components/Container.js